'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import usageTracker from '../../lib/usageTracker';
import ChecklistPage from './ChecklistPage';
import TrialCtaPage from './TrialCtaPage';
import LoadingPage from './LoadingPage';
import MobilePage from './MobilePage';
import OverallPage from './OverallPage';
import PerformancePage from './PerformancePage';
import SecurityPage from './SecurityPage';
import SeoPage from './SeoPage';
import ShareBanner from '../ShareBanner';
import OverallGrade from '../sidepanel/OverallGrade';
import GraderActionCreator from '../../actions/GraderActionCreator';
import PreviewActionCreator from '../../actions/PreviewActionCreator';
import MainToolBar from '../header/MainToolBar';
import { getWebsiteGrade } from '../../selectors/Grader';
export default (function () {
  var dispatch = useDispatch();
  var websiteGrade = useSelector(getWebsiteGrade);

  var _useParams = useParams(),
      websiteUrl = _useParams.websiteUrl;

  var loadWebsiteGrade = function loadWebsiteGrade() {
    dispatch(GraderActionCreator.getGrade(websiteUrl));
    dispatch(PreviewActionCreator.previewWebsite(websiteUrl));
  };

  useEffect(function () {
    usageTracker.logView('Results');
    loadWebsiteGrade();
    return function () {
      return dispatch(GraderActionCreator.resultsPageUnmounted());
    };
  }, []);

  var renderLoading = function renderLoading() {
    return /*#__PURE__*/_jsx(LoadingPage, {
      websiteUrl: websiteUrl
    });
  };

  var renderResults = function renderResults() {
    return /*#__PURE__*/_jsxs("div", {
      "data-test-id": "results-page",
      className: "column-container",
      children: [/*#__PURE__*/_jsx("div", {
        className: "left-column",
        children: /*#__PURE__*/_jsx(OverallGrade, {
          websiteGrade: websiteGrade
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "right-column",
        children: [/*#__PURE__*/_jsx(MainToolBar, {}), /*#__PURE__*/_jsx(OverallPage, {
          websiteGrade: websiteGrade
        }), /*#__PURE__*/_jsx(PerformancePage, {
          websiteGrade: websiteGrade
        }), /*#__PURE__*/_jsx(SeoPage, {
          websiteGrade: websiteGrade
        }), /*#__PURE__*/_jsx(MobilePage, {
          websiteGrade: websiteGrade
        }), /*#__PURE__*/_jsx(SecurityPage, {
          websiteGrade: websiteGrade
        }), /*#__PURE__*/_jsx(ChecklistPage, {
          websiteGrade: websiteGrade
        }), /*#__PURE__*/_jsx(ShareBanner, {}), /*#__PURE__*/_jsx(TrialCtaPage, {
          websiteUrl: websiteUrl
        })]
      })]
    });
  };

  if (websiteGrade.get('loading')) {
    return renderLoading(websiteGrade);
  } else {
    return renderResults(websiteGrade);
  }
});